"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Buttons = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Buttons = function (_a) {
    var loading = _a.loading, _b = _a.disabled, disabled = _b === void 0 ? false : _b, submit = _a.submit, errors = _a.errors, children = _a.children, className = _a.className, title = _a.title, approved = _a.approved;
    return react_1.default.createElement(react_1.default.Fragment, null,
        Boolean(errors.length) && react_1.default.createElement(storybook_1.Forms.Errors, { errors: errors }),
        react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-forms-buttons', className) },
            loading && react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader', className: 'storybook-icons-loader-form' }),
            !children && react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', disabled: loading || disabled, onClick: submit },
                approved && react_1.default.createElement(storybook_1.Icons.Icon, { name: 'check', className: 'storybook-icons-approved-form' }),
                title),
            children));
};
exports.Buttons = Buttons;
exports.Buttons.propTypes = {
    disabled: prop_types_1.default.bool,
    loading: prop_types_1.default.bool,
    submit: prop_types_1.default.func,
    title: prop_types_1.default.string,
    errors: prop_types_1.default.array,
};
exports.Buttons.defaultProps = {
    errors: [],
    title: 'Opslaan',
};
